import { connect } from 'react-redux';

import { IApplicationState } from '@store';
import { logIn } from '@store/actions';
import { CredentialsProps } from '@store/types';

import Login, { LoginStateProps } from '../components/login/Login';
interface IMapStateToProps
  extends Pick<IApplicationState, 'authentication' | 'customMessages'> {}

const mapStateToProps = ({
  authentication,
  customMessages,
}: IMapStateToProps): LoginStateProps => ({
  status: authentication.status,
  error: authentication.error,
  announcement: customMessages.notification,
  message: customMessages.marketing,
});

const mapDispatchToProps = (dispatch: any) => ({
  logIn: (credentials: CredentialsProps) => dispatch(logIn(credentials)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
